import { DataRoomMember } from './DataRoomMember';

export const DATA_ROOM_FAQ_ACCESS = {
  ALL: 'all',
  PARTICULAR_STAGE: 'particular_stage',
  SPECIFIC: 'specific',
};

export const FAQ_LEAD_STAGES = {
  enquire: 'enquiries',
  accept: 'accepted',
  confirm: 'prospects',
  offer: 'bidders',
} as const;

export type DataRoomFaqAccess =
  typeof DATA_ROOM_FAQ_ACCESS[keyof typeof DATA_ROOM_FAQ_ACCESS];
export type FaqLeadStages =
  typeof FAQ_LEAD_STAGES[keyof typeof FAQ_LEAD_STAGES];

export type DataRoomFaqAccessGranularityData = {
  buySideDataRoomMembers: DataRoomMember[];
  particularStages: {
    enquiries: string[];
    accepted: string[];
    prospects: string[];
    bidders: string[];
  };
};

export type FAQAccessForm = {
  faqAccess: DataRoomFaqAccess;
  faqAccessStages?: Record<FaqLeadStages, boolean>;
  accessDataRoomBuySideMemberIds?: Record<string, boolean>;
};

export type FAQAccessInfo = {
  faqAccess: DataRoomFaqAccess;
  faqAccessStages: FaqLeadStages[];
  accessDataRoomBuySideMemberIds: string[];
};

export type CreateFaqValues = {
  subject?: string;
  content?: string;
  answerContent?: string;
  isPublishedToFAQ?: boolean;
} & Partial<FAQAccessInfo>;
